import type { IEngagementTaskResponse } from '@features/engagement/api/engagement.type';
import { createSlice } from '@reduxjs/toolkit';
import { sortBy } from 'lodash';
import { engagementApi } from '../api/engagementApi';

const initialState = {
  tasks: [],
} as {
  tasks: IEngagementTaskResponse[];
};
export const engagementSlice = createSlice({
  name: 'engagement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(engagementApi.endpoints.fetchEngagementTasks.matchFulfilled, (state, action) => {
        if (Array.isArray(action.payload) && action.payload.length) {
          state.tasks = sortBy(action.payload, (task) => [ task.position ]);
        }
      });
  },
});
